import { CurrentsSteps } from "../interfaces/enums";
import { FirstStepView } from "../views/FirstStepView";
import ThirdStepView from "../views/ThirdStepView";
import FiveStepView from "../views/FiveStepView";
import SixStepView from "../views/SIxStepView";
import FinalStepView from "../views/FinalStep";
import EkatenaView from "../views/EkatenaView";

interface Props {
    currentStep: CurrentsSteps,
    Buttom: HTMLElement,
}

export const getCurrentStep = (currentStep: CurrentsSteps): JSX.Element => {
    switch (currentStep) {
        case CurrentsSteps.FirstStep:
            return <FirstStepView />

        case CurrentsSteps.FirstStepLeasing:
            return <FirstStepView />
    
        case CurrentsSteps.Ekatena:
            return <EkatenaView/>     
            
        case CurrentsSteps.ThirdStep:
            return <ThirdStepView />

        case CurrentsSteps.FifthStep:
            return <FiveStepView />
        
        case CurrentsSteps.SixStep:
            return <SixStepView />

        case CurrentsSteps.FinalStep:
            return <FinalStepView/>

        default:
            return <FinalStepView/>
    }
}